import { motion } from "framer-motion";

const CHAPTERS = [
  {
    number: "01",
    heading: "Cura dei Tuoi Spazi",
    text: "Pulizie interne ed esterne, aree verdi e traslochi: ogni servizio nasce per semplificarti la vita e il lavoro.",
  },
  {
    number: "02",
    heading: "Un Solo Interlocutore",
    text: "Pulizie, traslochi, verde, logistica e assistenza: parli con una sola azienda e risolvi tutto.",
  },
  {
    number: "03",
    heading: "Affidabilità Quotidiana",
    text: "Personale qualificato, mezzi propri e interventi puntuali. La nostra parola vale quanto un contratto.",
  },
  {
    number: "04",
    heading: "Verde e Territorio",
    text: "Puliamo, progettiamo e manteniamo aree verdi per privati, aziende, villaggi ed enti pubblici.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-mono text-xs uppercase tracking-[0.25em] text-neon"
        >
          {"// Chi Siamo — HELPLY SRLS"}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="mt-4 max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl lg:text-4xl"
        >
          Quattro principi. <span className="text-outline-cyan">Una sola promessa.</span>
        </motion.h2>

        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-[#D9E4F5] bg-[#D9E4F5] shadow-[0_20px_60px_rgba(22,52,95,0.08)] md:grid-cols-2">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.number}
              data-testid={`manifesto-chapter-${c.number}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group relative bg-white p-8 transition-colors duration-500 hover:bg-[#F0F6FD] lg:p-12"
            >
              <span className="pointer-events-none absolute right-6 top-4 font-display text-7xl font-black text-outline transition-all duration-500 group-hover:text-outline-cyan lg:text-8xl">
                {c.number}
              </span>
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-pulse">
                Capitolo {c.number}
              </p>
              <h3 className="mt-4 max-w-xs font-display text-xl font-semibold leading-snug sm:text-2xl">
                {c.heading}
              </h3>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-600 sm:text-base">
                {c.text}
              </p>
              <span className="mt-8 block h-px w-12 bg-neon/60 transition-all duration-500 group-hover:w-full group-hover:bg-neon" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
